import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-about",
    templateUrl: "./about.component.html",
    styleUrls: ["./about.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutComponent implements OnInit {
    // pure-SPA model: the host no longer injects a global appVersion, so source it from the backend
    appVersion = "";

    constructor(private readonly api: PerFormaAPIService) {}

    async ngOnInit(): Promise<void> {
        this.appVersion = (await lastValueFrom(this.api.getApiSystemVersion())) || "";
    }
}
